import React from "react";
import styles from "./deploy-style.module.css";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

export default class DeployTile extends React.PureComponent {
  render() {
    const { title, image, isLoading, isDone, isError, isActive, errors, onClick, middle } = this.props;

    return (
      <div
        className={isActive ? styles.deployTile : styles.deployTileNoHover}
        onClick={onClick && isActive ? () => onClick() : () => {}}
        title={
          isError
            ? "Error"
            : isLoading
              ? "Calculating Predictions"
              : title === "Upload Scoring Dataset"
                ? ""
                : "Coming Soon"
        }
        style={isError ? { opacity: 1 } : {}}
      >
        <div className={styles.topMessage}>{title}</div>
        {middle !== undefined && !isLoading ? (
          <div className={styles.icon}>{middle}</div>
        ) : isLoading ? (
          <LoadingIndicator />
        ) : isDone ? (
          <div>{"DONE"}</div>
        ) : isError ? (
          errors && errors.length > 0 ? (
            <OverlayTrigger
              placement="top"
              trigger={["click"]}
              overlay={
                <Popover id="popover-positioned-top" title={errors.length + " Error" + (errors.length > 1 ? "s" : "")}>
                  <div className={styles.wList}>
                    {errors.map((error, index) => (
                      <div key={index} className={styles.warnMsg}>
                        {type.message}
                      </div>
                    ))}
                  </div>
                </Popover>
              }
            >
              <div className={styles.warnH}>
                <div className={styles.warningIcon}>
                  <FontAwesomeIcon icon={faExclamationTriangle} />
                  <div className={styles.eMsg}>{"Click to see Errors"}</div>
                </div>
                <div className={styles.warningMessage}>{"Error"}</div>
              </div>
            </OverlayTrigger>
          ) : (
            <div className={styles.warnH}>
              <div className={styles.warningIcon}>
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </div>
              <div className={styles.warningMessage}>{"Error"}</div>
            </div>
          )
        ) : (
          <div className={styles.icon}>
            {image ? <img className={styles.iconImage} src={image} /> : <FontAwesomeIcon icon={faMagic} />}
          </div>
        )}
      </div>
    );
  }
}
